const api = [
    {
        id: 0,
        url: 'https://www.freecodecamp.org/news/content/images/2021/01/5-Projects-To-Include-in-Your-Frontend-Portfolio.png'
    },
    {
        id: 1,
        url: 'https://alvarotrigo.com/blog/assets/imgs/2021-10-16/dvlpr-front-end-portfolio-example.jpeg'
    },
    {
        id: 2,
        url: 'https://miro.medium.com/v2/resize:fit:1400/0*WDNhn6RqVm9RMWA3.jpg'
    },
    {
        id: 3,
        url: 'https://img-c.udemycdn.com/course/750x422/311538_d31f_3.jpg'
    },
    {
        id: 4,
        url: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRBxqZJLe_vpIxSCtBD0kYyzS1XB_v00ur-wg&s'
    },
    {
        id: 5,
        url: 'https://i.ytimg.com/vi/XKPRVkpkRms/maxresdefault.jpg'
    },
    {
        id: 6,
        url: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSrLQis5r6IBeO_REK3zXQEoZJKW-p_0d9iR4TdXw6DfzGKG-H0UY4hpEw76fV1tHJ71zU&usqp=CAU'
    },
    {
        id: 7,
        url: 'https://repository-images.githubusercontent.com/534924522/1cd07dfa-52e4-4eca-8057-702fa4a226c5'
    }
];

export default api